module.exports = __webpack_public_path__ + "static/media/person.7b6fe220.svg";